import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const tiles = [
  { to: '/numbers/destiny',    iconSrc: '/icons/numbers-destiny.png', titleKey: 'numbers.destiny_title',    descKey: 'numbers.destiny_desc' },
  // numbers-name.png is the watercolour for the "expression / number of name" tile.
  { to: '/numbers/expression', iconSrc: '/icons/numbers-name.png',    titleKey: 'numbers.expression_title', descKey: 'numbers.expression_desc' },
  { to: '/numbers/day',        iconSrc: '/icons/numbers-day.png',     titleKey: 'numbers.day_title',        descKey: 'numbers.day_desc' },
  { to: '/numbers/compat',     iconSrc: '/icons/numbers-compat.png',  titleKey: 'numbers.compat_title',     descKey: 'numbers.compat_desc' },
] as const

export function NumbersIndexRoute() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-5 pb-6">
      <header className="flex flex-col gap-1">
        <h1 className="font-serif text-2xl text-sage-800">{t('numbers.title')}</h1>
        <p className="text-sm text-sage-600">{t('numbers.index_intro')}</p>
      </header>
      <ul className="flex flex-col gap-3">
        {tiles.map((tile) => (
          <li key={tile.to}>
            <Link
              to={tile.to}
              className="flex items-center gap-3 rounded-2xl bg-white/70 p-4 ring-1 ring-sage-200/60 transition hover:bg-white active:scale-[0.99]"
            >
              <img
                src={tile.iconSrc}
                alt=""
                aria-hidden="true"
                className="h-10 w-10 shrink-0 select-none"
                draggable={false}
              />
              <div className="min-w-0 flex-1">
                <h3 className="font-serif text-lg text-sage-800">{t(tile.titleKey as never)}</h3>
                <p className="text-sm text-sage-600">{t(tile.descKey as never)}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
